import { isBefore } from '@fora-monorepo/date-utils';
import { ValidationResult, ValidationRule } from '@foradevelopment/fora-ui';

export const isLessThanOneYearAhead =
  (errorMessage: string): ValidationRule =>
  (value: string): ValidationResult => {
    const date = new Date();
    date.setUTCFullYear(date.getUTCFullYear() + 1);

    const isValid = isBefore(value, date.toISOString().split('T')[0]);
    return { error: !isValid, errorMessage };
  };
